'use client';

import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { curatorQueries } from '../../query-factory';
import type { RevenuePlatform } from '../../query-factory/revenue.factory';
import { BoostingPerformanceSection } from '../sections/BoostingPerformanceSection';
import { CuratorShopSection } from '../sections/CuratorShopSection';
import { EarningsSummarySection } from '../sections/EarningsSummarySection';
import { ProductCuratorLinkSection } from '../sections/ProductCuratorLinkSection';
import { DatePeriodSelector } from './DatePeriodSelector';

function serviceToPlatform(service: string): RevenuePlatform {
  if (service === SERVICE.MUSINSA) return 'MUSINSA';
  return 'TWENTY_NINE_CM';
}

export const EarningsSummaryPageView = () => {
  const { service } = useDeviceInfo();
  const platform = serviceToPlatform(service);

  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [selectedMonth, setSelectedMonth] = useState<number | null>(null);

  const handlePeriodChange = (year: number, month: number) => {
    setSelectedYear(year);
    setSelectedMonth(month);
  };

  const { data: revenueData } = useQuery({
    ...curatorQueries.revenue.monthlyRevenue(selectedYear!, selectedMonth!, platform),
    enabled: selectedYear !== null && selectedMonth !== null,
  });

  return (
    <div className="flex flex-col bg-white flex-1 safe-area-bottom">
      <div className="w-full flex flex-col pb-[72px]!">
        <DatePeriodSelector onPeriodChange={handlePeriodChange} />
        <EarningsSummarySection year={selectedYear} month={selectedMonth} platform={platform} />
        <ProductCuratorLinkSection
          goodsData={revenueData?.goods}
          isConfirmed={revenueData?.period.isConfirmed}
        />
        <CuratorShopSection
          curatorShopData={revenueData?.curatorShop}
          isConfirmed={revenueData?.period.isConfirmed}
        />
        <BoostingPerformanceSection boostingPerformance={revenueData?.boostingPerformance} />
      </div>
    </div>
  );
};
